import {config} from '../../config'
import Login from './Login'
import {RedirectLogin, RedirectSignUp, RedirectSignUpPartner} from './Redirect'
import RegisterStep1 from './Registration/RegisterStep1'

const ENABLE_NEW_AUTH_KEY = 'new_auth_enabled'

const isEnabledInLocalStorage = (): boolean => localStorage.getItem(ENABLE_NEW_AUTH_KEY) === 'true'
const isDisabledInLocalStorage = (): boolean =>
  localStorage.getItem(ENABLE_NEW_AUTH_KEY) === 'false'

const isNewAuthEnabled = () => {
  if (isEnabledInLocalStorage()) return true
  if (isDisabledInLocalStorage()) return false

  return Boolean(config.featuresConfig.enableNewAuth)
}

export function getLoginComponent() {
  if (isNewAuthEnabled()) return RedirectLogin

  return Login
}

export function getSignUpComponent() {
  if (isNewAuthEnabled()) return RedirectSignUp
  return RegisterStep1
}

export function getSignUpPartnerComponent() {
  if (isNewAuthEnabled()) return RedirectSignUpPartner
  return RegisterStep1
}
